import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import image3 from '../assets/1.webp';
import ScrollToBottomButton from '../components/ui/ScrollToBottomButton';


export default function ContactUs() {
  const location = useLocation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    number: '',
    subject: '',
    message: '',
  });

  useEffect(() => {
    if (location.hash) {
      const targetId = location.hash.substring(1);
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const phoneNumber = '919332730219';
    const message = `Name: ${formData.name}\nEmail: ${formData.email}\nNumber: ${formData.number}\nSubject: ${formData.subject}\nMessage: ${formData.message}`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
    setFormData({
      name: '',
      email: '',
      number: '',
      subject: '',
      message: '',
    });
  };

  return (
    <>
      <div className="relative min-h-[70vh] w-full overflow-hidden text-white">
        <img
          src={image3}
          alt="Lobby seating area"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40" />
        <div id="hero" className="relative z-10 flex min-h-[70vh] flex-col items-center justify-center gap-4 px-6 text-center" data-aos="fade-up">
          <span className="text-xs uppercase tracking-[0.3em] text-white/80">
            Get in touch
          </span>
          <h1 className="text-4xl font-semibold tracking-tight sm:text-5xl">
            Contact us
          </h1>
          <ScrollToBottomButton targetId="contact-us-main-content" />
        </div>
      </div>
      <div className="w-full bg-gray-50 text-dark-green flex justify-center px-4 py-16" data-aos="fade-up">
        <section id="contact-us-main-content" className="w-full max-w-7xl">
          <div className="mb-12 text-center">
            <h2 className="text-3xl font-semibold tracking-tight text-dark-green sm:text-4xl">We&apos;d love to hear from you!</h2>
            <p className="mt-4 max-w-3xl mx-auto text-lg leading-relaxed text-gray-600">
              Whether you&apos;re planning your stay, have questions, or need assistance, our team at pineridge Hotel is here to help. Reach out to us anytime—we&apos;re just a call or message away.
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-8 mb-16">
            <div className="bg-white p-8 rounded-lg shadow-md text-center">
              <div className="mb-4 text-beige">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" className="h-10 w-10 mx-auto">
                  <path d="M7 3h3l2 4-2 1c.6 1.4 1.6 2.7 2.9 3.9 1.2 1.2 2.5 2.1 3.9 2.7l1-2 4 2v3c0 1.1-.9 2-2 2C12.4 19.5 4.5 11.6 3 4 3 2.9 3.9 2 5 2h2z" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3 className="mb-2 text-lg font-semibold uppercase text-dark-green">Phone</h3>
              <p className="text-gray-600">+91 354 2254074</p>
              <p className="text-gray-600">+91 93327 30219</p>
              <p className="text-gray-600">(Available 8:00 AM – 10:00 PM)</p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-md text-center">
              <div className="mb-4 text-beige">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" className="h-10 w-10 mx-auto">
                  <rect x="3" y="5" width="18" height="14" rx="2" ry="2" stroke="currentColor" strokeWidth="1.4" />
                  <path d="M4 7l8 6 8-6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3 className="mb-2 text-lg font-semibold uppercase text-dark-green">Email</h3>
              <p className="text-gray-600">Reservations & General Queries:</p>
              <p className="text-gray-600">hotelpineridge@gmail.com</p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-md text-center">
              <div className="mb-4 text-beige">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" className="h-10 w-10 mx-auto">
                  <path d="M12 3a6 6 0 0 0-6 6c0 4.2 4.5 8.7 5.6 9.7.2.2.6.2.8 0C13.5 17.7 18 13.2 18 9a6 6 0 0 0-6-6z" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                  <circle cx="12" cy="9" r="2.5" stroke="currentColor" strokeWidth="1.4" />
                </svg>
              </div>
              <h3 className="mb-2 text-lg font-semibold uppercase text-dark-green">Address</h3>
              <p className="text-gray-600">The Mall, 19, Nehru Rd, Chauk Bazaar, Darjeeling, West Bengal 734101</p>
            </div>

            <div className="bg-white p-8 rounded-lg shadow-md text-center">
              <div className="mb-4 text-beige">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" className="h-10 w-10 mx-auto">
                  <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3 className="mb-2 text-lg font-semibold uppercase text-dark-green">Operating Hours</h3>
              <p className="text-gray-600">Front Desk: 24×7</p>
              <p className="text-gray-600">Reservations Team: 8:00 AM – 10:00 PM</p>
            </div>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-lg">
            <h2 className="text-2xl font-semibold text-center text-dark-green mb-6">Get in Touch</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Your Name</label>
                  <input type="text" name="name" value={formData.name} onChange={handleChange} className="w-full p-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-dark-green" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Your Email</label>
                  <input type="email" name="email" value={formData.email} onChange={handleChange} className="w-full p-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-dark-green" />
                </div>
              </div>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Your Number</label>
                  <input type="text" name="number" value={formData.number} onChange={handleChange} className="w-full p-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-dark-green" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
                  <input type="text" name="subject" value={formData.subject} onChange={handleChange} className="w-full p-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-dark-green" />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                <textarea rows="5" name="message" value={formData.message} onChange={handleChange} className="w-full p-3 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:border-dark-green"></textarea>
              </div>
              <div className="text-center">
                <button type="submit" className="inline-flex items-center px-12 py-3 text-sm font-semibold tracking-wider uppercase text-white bg-beige rounded-md hover:bg-dark-green transition-colors">
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </section>
      </div>
      <div className="w-full bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-semibold text-center text-dark-green mb-8">Our Location</h2>
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <a href="https://share.google/rwK69bTPdP3xU9t8B" target="_blank" rel="noopener noreferrer">
              <iframe 
                src="https://maps.google.com/maps?q=Pineridge+Hotel&ll=27.044098,88.1912389&z=13&output=embed" 
                width="100%" 
                height="450" 
                style={{border:0}} 
                allowFullScreen="" 
                loading="lazy"
                title="Pineridge Hotel Location Map"
                className="rounded-md"
              ></iframe>
            </a>
          </div>
          <div className="text-center mt-8">
            <a 
              href="https://maps.app.goo.gl/rimnn6hUMpsgay7f6"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-8 py-3 text-sm font-semibold tracking-wider uppercase text-white bg-dark-green rounded-md hover:bg-beige transition-colors"
            >
              Get Directions
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
